import { configureStore } from '@reduxjs/toolkit';
import thunk from 'redux-thunk';
import acceptFormReducer from '~src/domains/accept/state/acceptFormReducer';
import acceptReducer from '~src/domains/accept/state/acceptReducer';
import commonReducer from '~src/domains/common/state/commonReducer';
import invalidAddressFormReducer from '~src/domains/invalidAddress/state/invalidAddressFormReducer';
import invalidAddressReducer from '~src/domains/invalidAddress/state/invalidAddressReducer';
import loanConsentReducer from '~src/domains/loanConsent/state/loanConsentReducer';
import reacceptFormReducer from '~src/domains/reaccept/state/reacceptFormReducer';
import startFormReducer from '~src/domains/start/state/startFormReducer';
import startReducer from '~src/domains/start/state/startReducer';
import verifyFormReducer from '~src/domains/verify/state/verifyFormReducer';
import verifyReducer from '~src/domains/verify/state/verifyReducer';
import fullSSNFormReducer from '~src/domains/fullSSN/state/fullSSNFormReducer';

export const store = configureStore({
  reducer: {
    common: commonReducer,
    start: startReducer,
    verify: verifyReducer,
    accept: acceptReducer,
    loanConsent: loanConsentReducer,
    invalidAddress: invalidAddressReducer,
    // Input form states
    acceptForm: acceptFormReducer,
    startForm: startFormReducer,
    verifyForm: verifyFormReducer,
    invalidAddressForm: invalidAddressFormReducer,
    reacceptForm: reacceptFormReducer,
    fullSSNForm: fullSSNFormReducer,
  },
  middleware: [thunk],
  devTools: true,
});
